
const getFileSuffix=(file)=>
{
    let lastlen = file.lastIndexOf('.');
    if(lastlen>0)
    {
        return file.substring(lastlen + 1).trim().toLowerCase();
    }
    return "";
};

const getFileIcon=(file)=>
{
    let icon='word';
    let suf = getFileSuffix(file);
    switch(suf)
    {
        case 'doc':
        case 'docx':
            icon='word';
            break;
        case 'pdf':
            icon = 'pdf';
            break;
        case 'png':
        case 'jpg':
        case 'jpeg':
            icon='pic';
            break;
    }
    return icon;
}

const getParams=function()
{
    let url = decodeURIComponent(window.location.href); //获取url中"?"符后的字串
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.split("?")[1];
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++)
        {
            theRequest[strs[i].split("=")[0].toLowerCase()] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}

const isEmpty = (str) => {
    return !str || str.length === 0
}

const isBlank = (str) => {
    return (!str || /^\s*$/.test(str))
}

const getObjectUrl=(file)=>{
    let url = null;
    if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
    } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
    } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
    }
    return url;
}


const getFileType=(file)=>{
    return new Promise(function (resolve) {
        //https://filesignatures.net/
        // 如果系统无法获取文件类型，则读取二进制流，对二进制进行解析文件类型
        var imgType = [
            'FF D8 FF E0', //jpg
            'FF D8 FF E1', //jpg
            'FF D8 FF E8', //jpg

            '89 50 4E 47 0D 0A 1A 0A', //png

            'D0 CF 11 E0 A1 B1 1A E1', //doc
            '0D 44 4F 43', //doc
            'CF 11 E0 A1 B1 1A E1 00', //doc
            'DB A5 2D 00', //doc
            'EC A5 C1 00', //doc

            '50 4B 03 04', //docx
            '50 4B 03 04 14 00 06 00', //docx

            '25 50 44 46' //pdf
        ];
        var typeName = [
            'jpg',
            'jpg',
            'jpg',

            'png',

            'doc',
            'doc',
            'doc',
            'doc',
            'doc',

            'docx',
            'docx',

            'pdf'
        ];
        let sliceSize = 12;//imgType 最长的
        var reader = new FileReader();
        reader.onload = function (event) {
            var slice = event.target.result.slice(0, sliceSize);
            reader = null;
            if (slice && slice.byteLength == sliceSize) {
                var view = new Uint8Array(slice);
                var arr = [];
                view.forEach(function (v) {
                    arr.push(v.toString(16));
                });
                view = null;
                var filesignature = arr.join(' ');
                console.log(filesignature);
                for (var i = 0; i < imgType.length; i++) {
                    if (filesignature.indexOf(imgType[i].toLowerCase()) > -1) {
                        console.log(typeName[i]);
                        resolve(typeName[i]);
                        return;
                    }
                }
                resolve("");
            }
        }
        reader.readAsArrayBuffer(file);
    });
}

const getApp = () => {
    var userAgent=navigator.userAgent.toLowerCase();
    console.log('userAgent',userAgent);
    var isWeixin = (userAgent.indexOf('micromessenger') !== -1);
    if(isWeixin)
    {
        console.log('window.__wxjs_environment',window.__wxjs_environment);
        if (window.__wxjs_environment === 'miniprogram') {
            return 'WeiXinMini';//小程序
        }
        else
        {
            return 'WeiXin';//微信
        }
    }
    return 'M';
}

const getCookie=(name)=>{
    let strCookie=document.cookie;
    let arrCookie=strCookie.split(";");
    for(let i=0;i<arrCookie.length;i++)
    {
       let c=arrCookie[i].split('=');
       if(c[0]==name)
       {
           return decodeURIComponent(c[1]);
       }
    }
    return null;
}

const isIphoneX = () => {
    // X XS, XS Max, XR
    const xSeriesConfig = [
        {
            devicePixelRatio: 3,
            width: 375,
            height: 812,
        },
        {
            devicePixelRatio: 3,
            width: 414,
            height: 896,
        },
        {
            devicePixelRatio: 2,
            width: 414,
            height: 896,
        },
    ];
    // h5
    if (typeof window !== 'undefined' && window) {
        const isIOS = /iphone/gi.test(window.navigator.userAgent);
        if (!isIOS) return false;
        const { devicePixelRatio, screen } = window;
        const { width, height } = screen;
        return xSeriesConfig.some(item => item.devicePixelRatio === devicePixelRatio && item.width === width && item.height === height);
    }
    return false;
}

const isMobile=()=>{
    let mobile=false;
    var userAgent=navigator.userAgent.toLowerCase();
    let devices = ["android","iphone","ipad","blackberry","webos","windows phone","symbian","mobile","micromessenger"];
    for(let d of devices)
    {
        if(userAgent.indexOf(d.trim().toLowerCase())!=-1)
        {
            mobile= true;
            break;
        }
    }
    return mobile;
}
export default {
    getFileSuffix:getFileSuffix,
    getFileIcon:getFileIcon,
    getParams:getParams,
    isEmpty:isEmpty,
    isBlank:isBlank,
    getObjectUrl:getObjectUrl,
    getFileType:getFileType,
    getApp:getApp,
    getCookie:getCookie,
    isIphoneX:isIphoneX,
    isMobile:isMobile,
};
